import {observable, action} from 'mobx';

class Store {
  @observable limitHeight = true;

  @action.bound
  limitWrapHeight() {
    this.limitHeight = !this.limitHeight;
  }
}

export default new Store();
